<template>
  <div class="page-outbox">
    <!--表单-->
    <form name="editForm" class="edit-form addr-form" action="javascript:void(0)">
      <!--收获人-->
      <mt-field label="电子邮箱" class="inputcontent" readonly="" placeholder="" v-model="$store.state.userInfo.user_email"></mt-field>
      <div class="input-group">
        <p class="set-password" @click="switchPassword"><i class="mint-checkbox-core" :class="{'checked':setPassword}"></i>修改密码</p>
      </div>
      <template v-if="setPassword">
        <mt-field label="原密码" class="inputcontent required" type="password" placeholder="" v-model="oldPassword"></mt-field>
        <mt-field label="设置密码" class="inputcontent required" type="password" placeholder="" v-model="basicInfo.cus_password"></mt-field>
        <mt-field label="确认密码" class="inputcontent required" type="password" placeholder="" v-model="rePassword"></mt-field>
      </template>
      <mt-field label="姓名" class="inputcontent required" placeholder="" v-model="basicInfo.cus_name"></mt-field>
      <mt-field label="手机" class="inputcontent required" placeholder="" v-model="basicInfo.cus_mobile"></mt-field>
      <mt-field label="座机" class="inputcontent" placeholder="" v-model="basicInfo.cus_phone"></mt-field>
      <mt-field label="传值" class="inputcontent" placeholder="" v-model="basicInfo.cus_fax"></mt-field>
      <div class="opr-group">
        <mt-button size="large" type="danger" @click="saveBasicInfo">保存</mt-button>
      </div>
    </form>
  </div>
</template>

<script>
    export default {
        name: "editBasicInfo",
      data(){
          return{
            basicInfo:{
              cus_name:'',
              cus_password:'',
              cus_mobile:'',
              cus_phone:'',
              cus_fax:''
            },
            setPassword:false,
            oldPassword:'',
            rePassword:''
          }
      },
      mounted(){
        this.basicInfo.cus_name=this.$store.state.userInfo.user_name;
        this.basicInfo.cus_mobile=this.$store.state.userInfo.cus_mobile;
        this.basicInfo.cus_phone=this.$store.state.userInfo.cus_phone;
        this.basicInfo.cus_fax=this.$store.state.userInfo.cus_fax;
        //获取焦点时移到页面可见区域
        $('.inputcontent textarea,.inputcontent input').unbind('focus').bind('focus',function(e){
          var dom=e.target;
          setTimeout(function(){
            dom.scrollIntoView(true); dom.scrollIntoViewIfNeeded();
          }, 200);
        })
      },
      methods:{
        switchPassword(){
          this.setPassword=!this.setPassword;
        },
        saveBasicInfo(){
          //表单验证
          if(this.setPassword){
            if(!this.oldPassword){
              this.$toast('请输入原密码');
              return;
            }
            if(!this.basicInfo.cus_password){
              this.$toast('请输入新密码');
              return;
            }
            if(!this.rePassword){
              this.$toast('请重新输入密码');
              return;
            }
            if(this.basicInfo.cus_password!==this.rePassword){
              this.$toast('两次密码输入不一致');
              return;
            }
          }else{
            delete this.basicInfo.cus_password
          }
          if (!this.basicInfo.cus_name) {
            this.$toast('请输入姓名');
            return;
          }
          if (!this.basicInfo.cus_mobile) {
            this.$toast('请输入手机号码');
            return;
          } else if (!/^1[34578]\d{9}$/.test(this.basicInfo.cus_mobile)) {
            this.$toast('请输入正确的手机号');
            return;
          }
          //提交数据
          this.$cHttp.post('customers/profile',{
            partner:this.$systemConfig.partner,
            apikey:this.$systemConfig.apikey,
            user_id:this.$store.state.userInfo.user_id,
            old_password:this.oldPassword,
            ...this.basicInfo
          }).then((res)=>{
            console.log(res)
            if(res.status==1){
              this.$toast('修改成功！');
              //更新缓存的用户信息
              var curUserInfo=JSON.parse(JSON.stringify(this.$store.state.userInfo));
              curUserInfo.user_name=this.basicInfo.cus_name;
              curUserInfo.cus_mobile=this.basicInfo.cus_mobile;
              curUserInfo.cus_phone=this.basicInfo.cus_phone;
              curUserInfo.cus_fax=this.basicInfo.cus_fax;
              this.$store.commit('setUserInfo',curUserInfo);
            }else{
              this.$toast(res.error_msg);

            }
          }).catch((msg)=>{
            this.$toast(msg)
          })
        }
      }
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss" scoped>
  .edit-form{
    .set-password{
      padding: 10px 15px;
      padding-left: .55rem;
      font-size: .14rem;
      color: #666;
      background-color: #eee;
      .mint-checkbox-core{
        margin-right: .1rem;
        &.checked{
          background-color: $mainColor;
          border-color: $mainColor;
          &:after{
            border-color: #fff;
            transform: rotate(45deg) scale(1);
          }
        }
      }

    }
    .opr-group{
      margin-top: .4rem;
      padding: 0 .15rem;
      padding-bottom:.2rem;
      display: flex;
      .btn-div{
        min-width: .2rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/login/editBasicInfo.vue